"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// assets
//
const shippingCopy_1 = require("../../../../copy/shippingCopy");
const DateFormat_1 = require("../../../general/utility/DateFormat");
const RenderLogic_1 = require("../../RenderLogic");
//
// styles
//
const StyledModalHeader_1 = require("../StyledModalHeader");
const StyledModalSubHeader_1 = require("../StyledModalSubHeader");
const StyledHeaderContainer_1 = require("../StyledHeaderContainer");
const StyledModalCard_1 = require("../StyledModalCard");
const StyledCardHeader_1 = require("../StyledCardHeader");
const StyledCloseIcon_1 = require("../StyledCloseIcon");
const StyledIcon_1 = require("../StyledIcon");
const StyledSubHeader_1 = require("../../StyledSubHeader");
const StyledModalDataContainer_1 = require("../../StyledModalDataContainer");
const StyledArrivalContainer_1 = require("../../StyledArrivalContainer");
const StyledText_1 = require("../../Tables/StyledText");
const ModalButton_1 = __importDefault(require("../../Tables/ModalButton"));
// eslint-disable-next-line complexity
const ShippingModal = (props) => {
    const { shipment } = props;
    (0, react_1.useEffect)(() => {
        if (props.display) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.removeAttribute('style');
        }
    }, [props.display]);
    function handleClick(event) {
        if (event.target.id === 'modal-root') {
            props.handleToggleModal();
        }
    }
    function renderHeaderCell(carrier = '') {
        return (react_1.default.createElement(StyledCardHeader_1.StyledCardHeader, { className: 'card-header', lessPadding: true, top: true },
            react_1.default.createElement(StyledHeaderContainer_1.StyledHeaderContainer, { half: true },
                react_1.default.createElement(StyledModalHeader_1.StyledModalHeader, { className: 'card-header-title order-number' },
                    react_1.default.createElement(StyledText_1.StyledText, { bold: true, className: 'tracking-code' },
                        shipment.trackingCode,
                        react_1.default.createElement(ModalButton_1.default, { orderNumber: shipment.trackingCode })))),
            react_1.default.createElement(StyledHeaderContainer_1.StyledHeaderContainer, { half: true, right: true },
                react_1.default.createElement(StyledModalSubHeader_1.StyledModalSubHeader, { className: 'card-header-title order-time' },
                    react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-package', spaced: true }),
                    `${carrier || ''} | Parcel Select`))));
    }
    function renderBasicCell(title, data, delivery = false) {
        return (react_1.default.createElement(StyledCardHeader_1.StyledCardHeader, { className: 'card-header', lessPadding: true, top: true },
            react_1.default.createElement(StyledHeaderContainer_1.StyledHeaderContainer, { column: true, half: true },
                react_1.default.createElement(StyledSubHeader_1.StyledSubHeader, null, title),
                delivery ? (react_1.default.createElement(StyledArrivalContainer_1.StyledArrivalContainer, null,
                    react_1.default.createElement(StyledModalSubHeader_1.StyledModalSubHeader, { bold: true, className: 'card-header-title' }, data.value ? (0, DateFormat_1.shortDateFormat)(data.value) : '—'),
                    data.arrival ? (0, RenderLogic_1.renderArrival)(data.arrival) : '')) : (react_1.default.createElement(StyledModalSubHeader_1.StyledModalSubHeader, { bold: true, className: 'card-header-title' }, data.value ? (0, DateFormat_1.shortDateFormat)(data.value) : '—')))));
    }
    function renderOrderNumber(orderNumber = '') {
        return (react_1.default.createElement(StyledText_1.StyledText, { bold: true, className: 'tracking-code' },
            shippingCopy_1.shippingCopy.modaHeader1,
            orderNumber || ''));
    }
    return (react_1.default.createElement("div", { "aria-hidden": 'true', className: 'modal fade show', id: 'modal-root', onClick: handleClick, role: 'dialog', style: {
            display: `${props.display ? 'block' : 'none'}`
        }, tabIndex: -1 },
        react_1.default.createElement("div", { className: 'modal-dialog modal-dialog-centered modal-container', role: 'document' },
            react_1.default.createElement("div", { className: 'modal-content' }, shipment && shipment.order ? (react_1.default.createElement(StyledModalCard_1.StyledModalCard, { className: 'modal-card card', padding: true },
                react_1.default.createElement(StyledCardHeader_1.StyledCardHeader, { className: 'card-header', lessPadding: true, small: true, top: true },
                    react_1.default.createElement(StyledHeaderContainer_1.StyledHeaderContainer, null,
                        react_1.default.createElement(StyledModalHeader_1.StyledModalHeader, { className: 'card-header-title order-number' }, renderOrderNumber(shipment.order.number))),
                    react_1.default.createElement("button", { "aria-label": 'Close', className: 'close', "data-dismiss": 'modal', onClick: props.handleToggleModal, type: 'button' },
                        react_1.default.createElement(StyledCloseIcon_1.StyledCloseIcon, { "aria-hidden": 'true' }, "\u00D7"))),
                react_1.default.createElement(StyledModalDataContainer_1.StyledModalDataContainer, null,
                    renderHeaderCell(shipment.carrierName),
                    renderBasicCell(shippingCopy_1.shippingCopy.modaHeader3, {
                        value: shipment.order.placedAt
                    }),
                    renderBasicCell(shippingCopy_1.shippingCopy.modaHeader4, {
                        value: shipment.order.fulfilledAt
                    }),
                    renderBasicCell(shippingCopy_1.shippingCopy.modaHeader5, {
                        value: shipment.originalEstimatedDeliveryDate
                    }),
                    renderBasicCell(shippingCopy_1.shippingCopy.modaHeader6, { value: shipment.deliveredAt, arrival: shipment.arrival }, true)))) : (react_1.default.createElement(StyledModalCard_1.StyledModalCard, { className: 'modal-card card', padding: true }))))));
};
ShippingModal.propTypes = {
    display: prop_types_1.default.bool,
    handleToggleModal: prop_types_1.default.func,
    modalFunc: prop_types_1.default.func,
    shipment: prop_types_1.default.shape({
        arrival: prop_types_1.default.string,
        carrierName: prop_types_1.default.string,
        insertedAt: prop_types_1.default.string,
        fulfilled: prop_types_1.default.string,
        deliveredAt: prop_types_1.default.string,
        order: prop_types_1.default.shape({
            fulfilledAt: prop_types_1.default.string,
            number: prop_types_1.default.string,
            placedAt: prop_types_1.default.string
        }),
        originalEstimatedDeliveryDate: prop_types_1.default.string,
        trackingCode: prop_types_1.default.string
    })
};
exports.default = ShippingModal;
